import { Injectable, inject } from '@angular/core';
import { ApiUrl, IrisApiClient } from '@iris/api-query';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IrisDMSFolderOrFile } from '@iris/modules/dms/utils/file.utils';

export interface IrisDmsBulkActionParams {
  sync?: boolean;
  force?: boolean;
}

@Injectable({ providedIn: 'root' })
@ApiUrl('/dms2/{iris@instanceId}/bulk')
export class IrisDmsBulkActionsService extends IrisApiClient<IrisDMSFolderOrFile[]> {
  protected readonly http: HttpClient;

  constructor() {
    const http = inject(HttpClient);

    super(http);
  
    this.http = http;
  }

  @ApiUrl('~/check-linked/{folderId}')
  public checkLinked(folderId: string, includeIds: string[], excludeIds: string[]): Observable<string[]> {
    return this.httpClient.post<string[]>(this.url({ folderId }), this.applyParams(includeIds, excludeIds));
  }

  @ApiUrl('~/remove/{folderId}')
  public removeEntities(folderId: string, includeIds: string[], excludeIds: string[]): Observable<IrisDMSFolderOrFile[]> {
    return this.httpClient.post<IrisDMSFolderOrFile[]>(this.url({ folderId }), this.applyParams(includeIds, excludeIds, { sync: true }));
  }

  @ApiUrl('~/{folderId}/copy-to/{destinationId}')
  public copyEntities(folderId: string, destinationId: string, includeIds: string[], excludeIds: string[]): Observable<IrisDMSFolderOrFile[]> {
    return this.httpClient.post<IrisDMSFolderOrFile[]>(this.url({ folderId, destinationId }), this.applyParams(includeIds, excludeIds));
  }

  @ApiUrl('~/{folderId}/move-to/{destinationId}')
  public moveEntities(folderId: string, destinationId: string, includeIds: string[], excludeIds: string[]): Observable<IrisDMSFolderOrFile[]> {
    return this.httpClient.post<IrisDMSFolderOrFile[]>(this.url({ folderId, destinationId }), this.applyParams(includeIds, excludeIds));
  }

  private applyParams(includeIds: string[], excludeIds: string[], requestParams?: IrisDmsBulkActionParams): Record<string, unknown> {
    const params: Record<string, unknown> = {
      force: requestParams?.force ?? false,
      sync: requestParams?.sync ?? false,
    };
    if (includeIds) {
      params.includeIds = includeIds;
    }

    if (excludeIds) {
      params.excludeIds = excludeIds;
    }

    return params;
  }

  public getBulkActionParams(checkAll: boolean, selectedIds: string[], unselectedIds: string[]): [string[], string[]] {
    return checkAll ? [[], unselectedIds] : [selectedIds, []];
  }
}
